<template>
    <div class="chat-container w-100" :class="{ 'bg-white': this.isMobile }">
        <div v-if="this.isMobile" class="neue fsp20 lh28 text-black d-flex justify-content-between align-items-center mb32 px16">
            <div>
                <Icon name="arrow-left" class="c24 pointer" @click="this.closeMobileChat()"/>
            </div>
            <div class="flex-grow-1 fsp20 lh28 text-center mr24">
                {{ $t('views.P2P.P2PChat.2') }}
            </div>
            <div class="c24"></div> <!-- Spacer for centering -->
        </div>
        <div v-if="this.ready" class="chat-content" 
        :class="{ 'p24 mb-0': !this.isMobile, 'px16 pb-80': this.isMobile, 'content': !this.isMobile }">
            <div class="chat-block mb24">
                <div 
                    class="scroll-wrapper flex-grow-1" 
                    ref="scrollWrapper"
                >
                    <div 
                        class='scroll-menu container-fluid mt-1 p-0 g-3 d-flex flex-column' 
                        ref="scroll_menu" 
                        :style="`top: ${this.scrollPos}px;`"
                    >
                        <div 
                            v-for="(row, index) in this.msgs"
                            :key="index" 
                            :class="this.isThisMe(row.uid) ? 'align-self-end' : 'align-self-start'"
                            class="d-flex flex-column message-container mb16"
                            :style="{ marginTop: calculateMargin(index) }"
                        >
                            <div class="message d-flex flex-column">
                                <span v-if="getMessageGroupType(index) === 'single' || getMessageGroupType(index) === 'first'" 
                                    class="wraptext d-flex justify-content-between align-items-center mb6">
                                    <span v-if="row.author" class="neue-bold fsp14 lh20">{{ row.author }}</span>
                                    <span v-else-if="row.admin == '0'" class="neue-bold fsp14 lh20">{{ row.uid }}</span>
                                    <span class="fsp12 lh16">{{ this.formatDate(row.dt) }}</span>
                                </span>
                                <div class="mb-0 wraptext fsp16 lh24 px14 py10" 
                                    :class="[
                                        row.uid == this.$store.state.userData.id ? 'bg-menu-bg color-white' : 'bg-light-blue',
                                        'message-' + getMessageGroupType(index)
                                    ]" 
                                >
                                    <div v-if="row.text">{{ row.text }}</div>
                                    <div v-for="(file, index) in row.files" :key="index" class="d-flex flex-row pt-1 pointer" v-on:click="this.DownloadFile(file)">
                                        <div v-if="this.isImage(file.mime)">
                                            <img
                                                class="message-img"
                                                :src="'data:' + file.mime + ';base64,' + file.body" 
                                                alt="file" 
                                            >
                                        </div>
                                        <div v-else class="d-flex flex-row pt-1 pointer">
                                            <i class='item-i contain c24 mr-1' :class='"file_download"'></i>
                                            {{ file.name }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="this.smallloader" class="loader-r-cc2">
                            <Loading :active="this.smallloader"
                                :is-full-page="false"
                                :height='20'
                                :width='50'
                                :loader='"dots"'
                                :color='"#008D3E"'
                                :opacity='0'
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <div class='d-flex align-items-center g-3 position-relative m-0 message-send-wrapper'
                    :class="{ 'container-fluid px14': !this.isMobile, 'position-fixed bottom-0 left-0 end-0 py16 px24 w-100 border-t bg-white': this.isMobile }"
                >
                    <span
                        class="pointer files-btn"
                        @click='this.filesBlock = !this.filesBlock'
                    >
                        <Icon name="clip-files" size="c16" />
                    </span>
                    <textarea 
                        class="chat-textarea form-control fsp14 lh20" 
                        id="message"
                        :placeholder="$t('views.P2P.SingleSwap.35')"
                        v-model="this.data.message" 
                        @updateParentState="this.updateState"
                        @keydown.enter="this.handleEnterKey"
                    ></textarea>
                    <span 
                        class="btn-send"
                        :class="!this.data.message && !this.data.file.length > 0 ? 
                        'btn-send-disabled' : 'pointer'" 
                        @click="this.handleBtnSend"
                    >
                        <Icon name="message-send" size="c16" />
                    </span>
                </div>
                <div v-if="this.filesBlock" 
                    :class="{ 
                    'mt24': !this.isMobile, 
                    'position-fixed left-0 end-0 bg-white border-t w-100 files-block-mobile': this.isMobile 
                    }"
                >
                    <div class="files-uploader-wrapper">
                        <div class="files-uploader-container">
                            <Uploader 
                                id='file' 
                                arr
                                :dataValue='this.data.file' 
                                :fileName='this.file_name'
                                :fileIsImage="false"
                                @updateParentState="this.updateState" 
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Loading from 'vue-loading-overlay';
import Input from '@/components/service/Input';
import Button from '@/components/service/Button';
import FilePrime from '@/components/service/FilePrime';
import Icon from '@/components/icons/Icon';
import Uploader from '@/components/service/Uploader';

export default {
    components: {
        Loading,
        Input,
        Button,
        FilePrime,
        Icon,
        Uploader
    },
    props: {
        topic: [Object]
    },
    data () {
        return {
            t: false,
            msgs: [],
            data: {
                message: '',
                file: [],
            },
            ready: false,
            smallloader: false,
            f_key: 0,
            scrollPos: 0,
            filesBlock: false,
        }
    },
    computed: {
        isMobile() {
            return this.$store.state.resize.w <= 768
        }
    },
    mounted() {
        this.getMessages();
    },
    beforeUnmount() {
        if (this.t) {
            window.clearTimeout(this.t);
        }
    },
    methods: {
        getMessages() {
            this.axios.post('GetlistSupportMessages', {data: {topic: this.topic.ticket}}).then(res => {
                this.ready = true;
                if (res.data.body.result === '0') {
                    this.msgs = res.data.body.messages;
                    console.log('msgs', this.msgs);
                    this.data.file = [];
                    this.msgs.length > 0 ? this.checkScrollMessageBlock() : '';
                    this.t = setTimeout(() => {this.updateMessages()}, 5000);
                    this.msgs.forEach((item, index) => {
                        if (typeof item.text === 'string') {
                            this.msgs[index].text = item.text.replace(/\n\r?/g, '<br />');
                        }
                    });
                } else {
                    this.close();
                }
            });
        },
        updateMessages() {
            if (this.t) {
                window.clearTimeout(this.t);
            }
            let params = {
                topic: this.topic.ticket
            };
            if (this.msgs.length > 0 ) {
                params['last_read_message'] = this.msgs[this.msgs.length - 1].inc;
            }
            this.axios.post('GetlistSupportMessages', {no_loader: true, data: params}).then(res => {
                this.t = setTimeout(() => {this.updateMessages()}, 5000);
                if (res.data.body.messages.length > 0) {
                    res.data.body.messages.forEach(e => {
                        this.msgs.push(e);
                    });
                    this.checkScrollMessageBlock();
                    this.$emit('updateSwapStatus');
                }
            })
        },
        updateState(state) {
            this.data[state.id] = state.value;
        },
        calculateMargin(index) {
            if (index == 0) {
                return '0';
            }

            if (this.msgs[index].uid == this.msgs[index - 1].uid) {
                return '2px'
            }

            return '1.5rem'
        },
        handleEnterKey(event) {
            if (event.key === 'Enter') {
                if (this.data.message || this.data.file.length > 0) {
                    this.AddSupportMessage();
                }
            }
        },
        handleBtnSend() {
            if (this.data.message || this.data.file.length > 0) {
                    this.AddSupportMessage();
                }
        },
        scrollToEndMessageBlock(container, content) {
            const scrollPosition = container.scrollTop;
            const heightContent = content.offsetHeight;
            const difference = heightContent - scrollPosition;

            // Прокрутка с анимацией
            const duration = 500; // Продолжительность анимации в миллисекундах
            const startTime = performance.now();
            
            const animateScroll = (timestamp) => {
                const elapsed = timestamp - startTime;
                const progress = Math.min(elapsed / duration, 1); // Ограничиваем прогресс до 1
                container.scrollTop = scrollPosition + difference * progress;
                
                if (progress < 1) {
                    requestAnimationFrame(animateScroll);
                }
            };
            
            requestAnimationFrame(animateScroll);
        },
        checkScrollMessageBlock() {
            setTimeout(() => {
                const container = this.$refs.scrollWrapper;
                const content = this.$refs.scroll_menu;

                if (container && content) {
                    this.scrollToEndMessageBlock(container, content);
                }
            }, 500);
        },
        AddSupportMessage() {
            this.axios.post('AddSupportMessage', this.getData(),
            {headers: {
                    'Content-Type': 'multipart/form-data',
            }}).then(res => {
                if (res.data.body.result == '0') {
                    this.checkScrollMessageBlock();
                    this.data.message = '';
                    this.data.file = [];
                    this.msgs = res.data.body.messages;
                    this.f_key =  this.f_key + 1
                    this.filesBlock = false;
                    if (this.t) {
                        window.clearTimeout(this.t);
                    }

                }
            });
        },
        isImage(mimeType) {
            return mimeType && mimeType.startsWith('image');
        },
        DownloadFile(file) {
            if (this.isImage(file.mine)) {
                return;
            }
            else {
                let data = 'data:' + file.mime + ';base64,' + file.body;
                fetch(data).then(res => {
                    res.blob().then( blob => {
                        let url = URL.createObjectURL(blob);
                        this.Down(url, file.name);
                        URL.revokeObjectURL(url); 
                    });
                })
            }
        },
        Down(path, filename) {
            const anchor = document.createElement('a');
            anchor.href = path;
            anchor.download = filename;

            document.body.appendChild(anchor);


            anchor.click();

            document.body.removeChild(anchor);
        },
        getData() {
            let param = new FormData();
            param.append('topic', this.topic.ticket);
            param.append('message', this.data.message);
            
            console.log('file in form', this.data.file);
            if(this.data.file.length > 0) {
                this.data.file.forEach(e => {
                    param.append('file[]', this.$lib.base64ToFile(e.body, e.name, e.mime));
                })
            }
            return param;
        },
        isThisMe(uid) {
            return uid == this.$store.state.userData.id;
        },
        formatDate(dateString) {
            const date = new Date(dateString);
            const today = new Date();
            const yesterday = new Date(today);
            yesterday.setDate(yesterday.getDate() - 1);

            if (date.toDateString() === today.toDateString()) {
                return date.toLocaleTimeString('en-US', { hour12: false });
            } else if (date.toDateString() === yesterday.toDateString()) {
                return this.$t('views.P2P.P2PChat.1') + ' ' + date.toLocaleTimeString('en-US', { hour12: false });
            } else if (date.getFullYear() === today.getFullYear()) {
                return date.toLocaleDateString('en-US', { month: '2-digit', day: '2-digit' }) + ' ' + date.toLocaleTimeString('en-US', { hour12: false });
            } else {
                return date.toLocaleDateString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit' }) + ' ' + date.toLocaleTimeString('en-US', { hour12: false });
            }
        },
        shouldGroupWithPrevious(currentIndex) {
            if (currentIndex === 0) return false;
            
            const currentMsg = this.msgs[currentIndex];
            const previousMsg = this.msgs[currentIndex - 1];
            
            if (currentMsg.uid !== previousMsg.uid) return false;
            
            const currentTime = new Date(currentMsg.dt).getTime();
            const previousTime = new Date(previousMsg.dt).getTime();
            const timeDiff = currentTime - previousTime;
            
            return timeDiff <= 120000;
        },
        shouldGroupWithNext(currentIndex) {
            if (currentIndex === this.msgs.length - 1) return false;
            
            const currentMsg = this.msgs[currentIndex];
            const nextMsg = this.msgs[currentIndex + 1];
            
            if (currentMsg.uid !== nextMsg.uid) return false;
            
            const currentTime = new Date(currentMsg.dt).getTime();
            const nextTime = new Date(nextMsg.dt).getTime();
            const timeDiff = nextTime - currentTime;
            
            return timeDiff <= 120000;
        },
        getMessageGroupType(index) {
            const groupedWithPrevious = this.shouldGroupWithPrevious(index);
            const groupedWithNext = this.shouldGroupWithNext(index);
            
            if (!groupedWithPrevious && !groupedWithNext) return 'single';
            if (!groupedWithPrevious && groupedWithNext) return 'first';
            if (groupedWithPrevious && groupedWithNext) return 'middle';
            if (groupedWithPrevious && !groupedWithNext) return 'last';
            
            return 'single';
        },
        closeMobileChat() {
            this.$emit('close-mobile-chat');
        }
    }
}
</script>

<style lang="scss" scoped>
.loader-r-cc {
    min-height: 100px;
    position: relative;
}
.loader-r-cc2 {
    min-height: 15px;
    position: relative;
}
.wraptext {
    overflow-wrap: anywhere;
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
    border-bottom-left-radius: 8px;
}

.fixed-wrapper {
    position: sticky;
}
.scroll-menu {
    position: absolute;
    left: 0;
    right: 0;
    width: calc(100% - 2px);
    max-height: fit-content;
}
.scroll-wrapper {
    overflow-y: auto;
    -ms-overflow-style: none;
    position: relative;
    z-index: 10;
    flex: 1;
    min-height: 300px;

    @media (max-width: 768px) {
        min-height: 600px;
    }
}

.scroll-wrapper,
.chat-textarea {
    &::-webkit-scrollbar {
        width: 6px;
        border-radius: 20px;               /* width of the entire scrollbar */
    }

    &::-webkit-scrollbar-track {
        background: white;
        border-radius: 20px;        /* color of the tracking area */
    }

    &::-webkit-scrollbar-thumb {
        background-color: $menu-bg;    /* color of the scroll thumb */
        border-radius: 20px;       /* roundness of the scroll thumb */
        border: 1px solid white;  /* creates padding around scroll thumb */
    }
}

.chat-block {
    background-size: contain;
    margin-bottom: 0;
    position: relative;
    border-radius: 12px 12px 0 0;

    @media(max-width: 768px) {
        border-radius: 12px;
    }
}

.message-send-wrapper,
.message {
    background: white;
}

.message-send-wrapper {
    border-radius: 8px;
    height: 56px;
    border: 1px solid $primary-stroke;
}

.message {
    border-radius: 0.5rem;
}

.message-img {
    max-width: 200px;
    max-height: 200px;
}

.chat-textarea {
    resize: none;
    border: none;
    height: 26px;
    padding-top: 8px;
    padding-bottom: 4px;
}

.chat-textarea:focus,
.chat-textarea:focus-visible{
    outline: none;
    border: none;
    box-shadow: none;
}

.btn-send {
    width: 32px;
    min-width: 32px;
    height: 32px;
    border-radius: 50%;
    background: $menu-bg;
    display: flex;
    align-items: center;
    justify-content: center;
}

.btn-send-disabled {
    filter: saturate(10%);
}

.message-single,
.message-first {
    border-top-right-radius: 8px;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
}

.message-middle,
.message-last {
    border-radius: 8px;
}

.message-container.mb16 {
    &:has(.message-first),
    &:has(.message-middle),
    &:has(.message-last) {
        margin-bottom: 2px !important;
    }
}

.files-btn {
    background: $primary-stroke;
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 32px;
    width: 32px;
    height: 32px;
    border-radius: 50%;
}

// Стили для растягивания чата по высоте
.chat-container {
    min-height: 600px;
    height: 100%;
    display: flex;
    flex-direction: column;
}

.chat-content {
    height: 100%;
    display: flex;
    flex-direction: column;
}

.chat-block {
    flex: 1;
    display: flex;
    flex-direction: column;
    min-height: 400px;
}

.files-block-mobile {
    bottom: 80px;
    z-index: 1000;
    padding: 16px 0 0 0;
}

.files-uploader-wrapper {
    width: 100%;
    display: flex;
    justify-content: center;
}

.files-uploader-container {
    width: 100%;
    
    @media (max-width: 768px) {
        max-width: 280px;
    }
}
</style>